import Loadable from 'react-loadable';

const getComponentImport = componentName => {
  if (!componentName) return null;
  switch (componentName) {
    case 'AirPollutionWidget':
      return import(/* webpackChunkName: 'AirPollutionWidgetLoader' */ 'components_v2/common/AirPollutionWidget');
    case 'Podcast':
      return import(/* webpackChunkName: 'PodcastLoader' */ 'components_v2/Podcasts/Podcast');
    case 'PollWidget':
      return import(/* webpackChunkName: 'pollwidget' */ 'components_v2/common/PollWidget/PollWidgetMain');
    case 'BlockedNotificationCard':
      return import(/* webpackChunkName: 'BlockedNotificationCardLoader' */ 'components_v2/common/BlockedNotificationCard/BlockedNotificationCard');
    case 'CustomNotificationPrompt':
      return import(/* webpackChunkName: 'CustomNotificationPromptLoader' */ 'components_v2/common/CustomNotificationPrompt/CustomNotificationPrompt');
    case 'FloatingOpenInApp':
      return import(/* webpackChunkName: 'FloatingOpenAppLoader' */ 'components_v2/common/FloatingOpenInApp/FloatingOpenInApp');
    case 'NewsCardComponent':
      return import(/* webpackChunkName: 'NewsCardComponentLoader' */ 'components_v2/common/InitNewscardComponents/index');
    case 'ListingWidget':
      return import(/* webpackChunkName: 'ListingWidgetLoader' */ 'components_v2/common/ListingWidget/ListingWidget');
    case 'MidArticleSearch':
      return import(/* webpackChunkName: 'MidArticleSearchLoader' */ 'components_v2/mobile/MidArticleSearch/MidArticleSearch');
    case 'BottomAdLayer':
      return import(/* webpackChunkName: 'BottomAdLayerLoader' */ 'routes/articleshow/BottomAdLayer');
    case 'CricketScorecard':
      return import(/* webpackChunkName: 'LoadableCricketScoreCard' */ 'routes/articleshow_v2/components/common/CricketScorecard/CricketScorecard');
    case 'NewsCoverage':
      return import(/* webpackChunkName: 'newscoverage' */ 'routes/articleshow_v2/components/common/NewsCoverage/NewsCoverage');
    case 'PopularFromSection':
      return import(/* webpackChunkName: 'PopularFromSectionLoader' */ 'routes/articleshow_v2/components/common/PopularFromSection/PopularFromSection');
    case 'NextArticlesBottomWidget':
      return import(/* webpackChunkName: 'NextArticlesBottomWidgetLoader' */ 'routes/articleshow_v2/components/common/NextArticlesBottomWidget/NextArticlesBottomWidget');
    case 'PdfEmbed':
      return import(/* webpackChunkName: 'PdfEmbedLoader' */ 'routes/articleshow_v2/components/common/PdfEmbed/PdfEmbed');
    case 'PixelEmbedVideo':
      return import(/* webpackChunkName: 'PixelEmbedVideo' */ 'routes/articleshow_v2/components/common/PixelEmbedVideo/PixelEmbedVideo');
    case 'Slideshow':
      return import(/* webpackChunkName: 'SlideshowLoader' */ 'routes/articleshow_v2/components/common/Slideshow/Slideshow');
    case 'TopComment':
      return import(/* webpackChunkName: 'TopCommentLoader' */ 'routes/articleshow_v2/components/common/TopComment/TopComment');
    // case 'FloatingSharing':
    //   return import(/* webpackChunkName: 'FloatingSharingLoader' */ 'routes/articleshow_v2/components/mobile/FloatingSharing/FloatingSharing');
    case 'SocialSharingMobile':
      return import(/* webpackChunkName: 'SocialSharingMobileLoader' */ 'routes/articleshow_v2/components/mobile/SocialSharingMobile/SocialSharingMobile');
    case 'SocialSharingWeb':
      return import(/* webpackChunkName: 'SocialSharingWebLoader' */ 'routes/articleshow_v2/components/desktop/SocialSharingWeb');
    case 'TileLayout':
      return import(/* webpackChunkName: 'TileLayoutLoader' */ 'routes/home/components/mobile/TileLayout/TileLayout');
    case 'WithSocials':
      return import(/* webpackChunkName: 'Socials' */ 'components_v2/desktop/Header/Socials/WithSocials');
    case 'ToiSubscriptionLoader':
      return import(/* webpackChunkName: 'ToiSubscriptionLoader' */ 'components/ToiSubscription/ToiSubscriptionFlowCaller');
    case 'ScorecardWithAd':
      return import(/* webpackChunkName: 'ScorecardWithAdLoader' */ 'components_v2/common/ScorecardWithAd');
    case 'SocialWidgetVideoshow':
      return import(/* webpackChunkName: 'SocialWidgetVideoshow' */ 'routes/videoshow/components/common/SocialWidget');
    case 'TopicFilter':
      return import(/* webpackChunkName: 'TopicFilter' */ 'routes/topic/components/Mobile/Filter/Filter');
    case 'StickyDiv':
      return import(/* webpackChunkName: 'Stickydiv' */ 'components/StickyDiv/index');
    case 'SignalsReadNextContainer':
      return (
        import(/* webpackChunkName: 'SignalsReadNextContainer' */ 'facto-ui')
          .then(
            // eslint-disable-next-line no-return-assign
            module =>
              (module.default = module.SignalsReadNextContainer || null),
          )
          // eslint-disable-next-line no-return-assign
          .catch(module => (module.default = null))
      );
    case 'ScriptLoader':
      return import(/* webpackChunkName: 'ScriptLoader' */ 'components_v2/common/ScriptLoader/ScriptLoader');
    case 'ETNewsLetterSubscriptionModal':
      return import(/* webpackChunkName: 'NativeCard' */ 'components_v2/desktop/ETNewsLetter/ETNewsLetterSubscriptionModal');
    case 'WithMediawireStories':
      return import(/* webpackChunkName: 'WithMediawireStories' */ '../modules/WithMediawireStories/WithMediawireStories');
    case 'BannerSlider':
      return import(/* webpackChunkName: 'BannerSlider' */ 'components_v2/mobile/BannerSlider/BannerSlider');
    case 'CompareWidget':
      return import(/* webpackChunkName: 'CompareWidget' */ 'routes/home/components/mobile/CompareWidget/CompareWidget');
    case 'IPLWidgetV2':
      return import(/* webpackChunkName: 'IPLWidgetV2' */ 'components_v2/mobile/IPLWidget_v2/IPLWidget');
    case 'IPLWidgetV2LoaderWrapper':
      return import(/* webpackChunkName: 'IPLWidgetV2LoaderWrapper' */ 'components_v2/mobile/IPLWidget_v2/IPLWidgetV2LoaderWrapper');
    case 'IPLWidget':
      return import(/* webpackChunkName: 'IPLWidget' */ 'components_v2/mobile/IPLWidget');
    case 'VideoWidget':
      return import(/* webpackChunkName: 'VideoWidget' */ 'routes/articleshow_v2/components/common/VideoWidget');
    case 'VideoActionController':
      return import(/* webpackChunkName: 'VideoActionController' */ 'routes/articleshow_v2/components/mobile/VideoActionController');
    case 'VideoActionControllerWeb':
      return import(/* webpackChunkName: 'VideoActionControllerWeb' */ 'routes/articleshow_v2/components/desktop/VideoActionController');
    case 'TimesAssist':
      return import(/* webpackChunkName: 'TimesAssist' */ 'components_v2/common/TimesAssist/TimesAssist');
    case 'FakeNews':
      return import(/* webpackChunkName: 'FakeNews' */ 'components_v2/common/FakeNews/FakeNews');
    case 'Audio':
      return import(/* webpackChunkName: 'Audio' */ 'components_v2/common/Audio/Audio');
    case 'GoogleSubscriptionLink':
      return import(/* webpackChunkName: 'GoogleSubscriptionLink' */ 'components_v3/GoogleSubscriptionLink/GoogleSubscriptionLink');
    case 'SubscriptionStripWrapper':
      return import(/* webpackChunkName: 'SubscriptionStripWrapper' */ 'components_v3/GoogleSubscriptionLink/SubscriptionStripWrapper');
    case 'PrimeRenewStrip':
      return import(/* webpackChunkName: 'PrimeRenewStrip' */ 'components_v2/common/ToipNudges/PrimeRenewStrip/PrimeRenewStrip');
    case 'EtimesCoverLayout':
      return import(/* webpackChunkName: 'EtimesCoverLayout' */ 'components_v2/desktop/EtimesCoverLayout/EtimesCoverLayout');
    case 'SocialWidgetVSDesktop':
      return import(/* webpackChunkName: 'SocialWidgetVSDesktop' */ 'routes/articleshow_v2/components/common/SocialWidget/SocialWidget');
    case 'Adcaller':
      return import(/* webpackChunkName: 'Adcaller' */ 'helpers/ads/adCaller');
    case 'AiSuggestion':
      return import(/* webpackChunkName: 'AiSuggestion' */ 'components_v2/common/AiSuggestion/AiSuggestion');

    case 'CommentFirstView':
      return import(/* webpackChunkName: 'CommentFirstView' */ 'components_v2/common/Comments/CommentFirstView/CommentFirstView');
    case 'NativeLangSynopsis':
      return import(/* webpackChunkName: 'NativeLangSynopsis' */ 'components_v2/common/NativeLangSynopsis/NativeLangSynopsis');
    default:
      return null;
  }
};

const getComponent = (component = '') => {
  if (!component) return null;
  return null;
  // return new Promise(resolve => {
  //     getComponentImport(component).then(
  //       comp => {
  //         resolve(comp.default);
  //       },
  //     );
  //   });
};

const getComponents = async (components = []) => {
  const widgetPromises = [];
  const componentsMap = {};
  components.forEach(component => {
    const compPromise = getComponent(component);
    if (compPromise) {
      widgetPromises.push(
        compPromise.then(compWidget => {
          componentsMap[component] = compWidget;
        }),
      );
    }
  });
  await Promise.all(widgetPromises);
  return componentsMap;
};

const getLoadableComponent = componentName => {
  if (!componentName) return null;

  return Loadable({
    loader: () => getComponentImport(componentName),
    loading: () => null,
  });
};

export { getComponents, getLoadableComponent };
